import React, { useEffect, useState } from 'react'

import Pagination from '../../../ui/Pagination';
import axios from 'axios'
import { HeaderTable } from '../../../HeaderTable';
import RefundsTable from './RefundsTable';
import WalletBalance from './WalletBalance';
import ModleNewRefuond from './ModleNewRefuond';

const Refunds = ({ row }) => {
    const [modalIsOpen, setModalIsOpen] = useState("");
    const [fetchData, setFetchData] = useState([])
    const [loading, setloading] = useState(true)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1)
const GET_URL = `admin/member/get_private_entitlement/${row?.id}`


    const handleColse = () => {
        setModalIsOpen("")
    }
    const getMemberships = async (page) => {
        setloading(true);
        await axios.get(GET_URL, {
            params: {
                // ...dataFillter,
                "page": page
                , "size": perPage,
                // "sortName": "startDate",


            }
        })
            .then(response => {
                setFetchData(response?.data)
                // setTotalRows(1);
                setTotalRows(response?.data?.totalPages||0);
            })
        setloading(false)

    }
    const handlePageChange = (page) => {
        // fetchUsers(page);
        getMemberships(page - 1);
        setCurrentPage(page);
    };
    useEffect(() => {
        getMemberships(currentPage - 1)
    }, [currentPage, perPage])
    return (
        <div className='w-full  p-3'  style={{ direction: "ltr" }}>

            <HeaderTable active={"זכאות"} 
                setModalIsOpen={setModalIsOpen}
            // downloadExcel={downloadExcel} howmach={fetchData?.length}
            />
            <WalletBalance balance={fetchData?.balance || 0} currency="₪" loading={loading} error={fetchData?.error || null} />
            <RefundsTable members={fetchData?.listEntitlements || []} loading={loading} />

            {/* <Pagination currentPage={currentPage} totalPages={totalRows} onPageChange={handlePageChange} /> */}
            {modalIsOpen == "New" && <ModleNewRefuond isOpen={modalIsOpen == "New"} onClose={handleColse} onSuccess={getMemberships} memberId={row?.id} />}

        </div>
    )
}

export default Refunds